import { render } from "./personage.vue?vue&type=template&id=8db66b96"
import script from "./personage.vue?vue&type=script&lang=js"
export * from "./personage.vue?vue&type=script&lang=js"

import "./personage.vue?vue&type=style&index=0&id=8db66b96&lang=scss"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__